import { ActivatedRoute, ParamMap } from '@angular/router';
import { AuthService } from '@account/services/auth.service';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { LoginResponse } from '@account/models/login-response.model';
import { SessionIdleService } from './auxiliary/shared/services/session-idle.service';
import { Subscription, take } from 'rxjs';
import { TranslationManagerService } from '@globalization/services/translation-manager.service';
import { URL_PARAM_LANG } from './auxiliary/config/app-config';

@Component({
  selector: 'bv-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private authService: AuthService = inject(AuthService);
  private idleService: SessionIdleService = inject(SessionIdleService);
  private translationManagerService: TranslationManagerService = inject(TranslationManagerService);

  public ngOnInit(): void {
    if (this.authService.shouldLogoutUserOnInactivity()) {
      this.configureUnlogUserOnInactivity();
    }

    this.translationManagerService.init();
    this.activatedRoute.queryParamMap.subscribe((params: ParamMap) => {
      const lang = params.get(URL_PARAM_LANG);
      if (lang) this.translationManagerService.setCurrentLang(lang);
    });
    Date.prototype.toJSON = function (): string {
      return this.toDateString();
    }
  }

  private configureUnlogUserOnInactivity(): void {
    this.authService.getLoggedUserProfile().pipe(take(1)).subscribe(
      {
        next: ((response: LoginResponse) => {
          if (response.isAuthenticated) this.idleService.beginIdleTracking();
        })
      });

    this.configureLogginEvents();
  }

  private configureLogginEvents(): void {
    this.subscriptions.add(this.authService.onLoggedIn$.subscribe(() => { this.idleService.beginIdleTracking(); }));
    this.subscriptions.add(this.authService.onLoggedOut$.subscribe(() => { this.idleService.endIdleTracking(); }));
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
